import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { MessageCircle, TrendingUp, Stethoscope, Heart, GraduationCap, Star, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

const iconMap = {
  MessageCircle,
  TrendingUp,
  Stethoscope,
  Heart,
  GraduationCap,
  Star
};

const Sidebar = ({ categories, selectedCategory, onSelectCategory }) => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      {/* Categories Card */}
      <Card className="border-stone-200 rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-['Outfit'] text-stone-800">Categories</CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          <Button
            variant="ghost"
            onClick={() => onSelectCategory(null)}
            className={`w-full justify-start rounded-xl ${!selectedCategory ? 'bg-[#6B8E7B]/10 text-[#6B8E7B]' : 'text-stone-600'}`}
            data-testid="category-all"
          >
            All Posts
          </Button>
          {categories.map(cat => {
            const IconComponent = iconMap[cat.icon] || MessageCircle;
            return (
              <Button
                key={cat.id}
                variant="ghost"
                onClick={() => onSelectCategory(cat.id)}
                className={`w-full justify-start rounded-xl ${selectedCategory === cat.id ? 'bg-[#6B8E7B]/10 text-[#6B8E7B]' : 'text-stone-600'}`}
                data-testid={`category-${cat.id}`}
              >
                <IconComponent className="h-4 w-4 mr-2" />
                {cat.name}
              </Button>
            );
          })}
        </CardContent>
      </Card>

      {/* Premium Card */}
      {!user?.is_premium && (
        <Card className="anonymous-card rounded-2xl border-[#E27D60]/20">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 mb-3">
              <Lock className="h-5 w-5 text-[#E27D60]" />
              <span className="font-semibold text-stone-800 font-['Outfit']">Go Premium</span>
            </div>
            <p className="text-sm text-stone-600 mb-4">
              Share your worries anonymously and access exclusive support features.
            </p>
            <Link to="/subscribe">
              <Button className="btn-premium w-full" data-testid="sidebar-subscribe-button">
                €5/month
              </Button>
            </Link>
          </CardContent>
        </Card>
      )}

      {/* Quick Links */}
      <Card className="border-stone-200 rounded-2xl">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-['Outfit'] text-stone-800">Quick Links</CardTitle>
        </CardHeader>
        <CardContent className="space-y-1">
          <Link to="/profile">
            <Button variant="ghost" className="w-full justify-start rounded-xl text-stone-600" data-testid="sidebar-profile-link">
              My Profile
            </Button>
          </Link>
          <Link to="/messages">
            <Button variant="ghost" className="w-full justify-start rounded-xl text-stone-600" data-testid="sidebar-messages-link">
              Messages
            </Button>
          </Link>
          {user?.is_premium && (
            <Link to="/anonymous">
              <Button variant="ghost" className="w-full justify-start rounded-xl text-stone-600" data-testid="sidebar-anonymous-link">
                <Lock className="h-4 w-4 mr-2 text-[#E27D60]" />
                Anonymous Sharing
              </Button>
            </Link>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default Sidebar;
